import { registerEntityEndpoint as e } from "@editor/ui-utils";
//#region ../../../framework/utils/brands/dist/brandEnums.js
var t;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.FITFORFUN = "fitforfun", e.FINANZEN100 = "finanzen100", e.MITTIER = "mittier", e.MITSTERNEN = "mitsternen", e.MITBEZIEHUNG = "mitbeziehung", e.TVTODAY = "tvtoday", e.TVSPIELFILM = "tvspielfilm";
})(t ||= {}), Object.freeze(t);
var n;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.PRAXISTIPPS = "praxistipps";
})(n ||= {}), Object.freeze(n), Object.freeze([
	t.MITTIER,
	t.MITSTERNEN,
	t.MITBEZIEHUNG,
	t.TVTODAY,
	t.TVSPIELFILM
]), Object.freeze({
	[t.BUNTE]: "bunte",
	[t.CHIP]: "chip",
	[t.FOCUS]: "focus",
	[t.FITFORFUN]: "fitforfun",
	[t.FINANZEN100]: "finanzen100",
	[t.MITTIER]: "default-verticals",
	[t.MITSTERNEN]: "default-verticals",
	[t.MITBEZIEHUNG]: "default-verticals",
	[t.TVTODAY]: "default",
	[t.TVSPIELFILM]: "default"
}), Object.freeze(Object.values(t)), Object.freeze(Object.values(n)), t.BUNTE, t.CHIP, t.FOCUS, t.FITFORFUN, t.TVSPIELFILM, t.TVTODAY, t.BUNTE, t.CHIP, t.FOCUS, t.FITFORFUN, t.TVSPIELFILM, t.TVTODAY;
//#endregion
//#region ../../../framework/ctf-config/dist/generalEnums.js
var r;
(function(e) {
	e.LOCAL = "local", e.LOCAL_K8S = "local_k8s", e.LOCAL_E2E = "local_e2e", e.SANDBOX = "sandbox", e.DEVELOPMENT = "development", e.STAGING = "staging", e.PRODUCTION = "production", e.TEST = "test";
})(r ||= {});
//#endregion
//#region ../../../framework/ctf-config/dist/configHelper.js
function i(e) {
	return a(e);
}
function a(e) {
	return Object.getOwnPropertyNames(e).forEach((t) => {
		let n = e[t];
		n && (typeof n == "object" || typeof n == "function") && !Object.isFrozen(n) && a(n);
	}), Object.freeze(e);
}
function o(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function s(e) {
	return o(e);
}
function c(e) {
	return o(e);
}
function l(e) {
	return typeof e == "function";
}
function u(e) {
	return Object.fromEntries(Object.entries(e));
}
function d(e, t) {
	let n = {}, r = u(t), i = u(e);
	for (let e of Object.keys({
		...r,
		...i
	})) {
		let t = r[e], a = i[e];
		o(t) && c(a) ? n[e] = d(a, t) : l(a) ? n[e] = a.bind(n) : l(t) ? n[e] = t.bind(n) : e in i ? n[e] = a : n[e] = t;
	}
	if (!s(n)) throw Error("merged config is not an object");
	return n;
}
function f(e) {
	return Object.values(r).find((t) => t === e) !== void 0;
}
function p() {
	let e = process.env.APP_ENV;
	if (e === void 0) throw Error("APP_ENV is undefined.\nHint: configuration should be initialized lazily during runtime and not during build time.");
	if (!f(e)) throw Error(`APP_ENV=${e}. Allowed values=${Object.values(r).join(", ")}`);
	return e;
}
var m = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap();
function g(e, t) {
	let n = m.get(e), r = n?.get(t);
	if (s(r)) return r;
	let { base: a, ...o } = e, c;
	c = typeof process > "u" ? o.local : o[p()];
	let l = h.get(e), u = s(l) ? l : void 0;
	u === void 0 && (u = c ? d(c, a) : a, h.set(e, u));
	let { _: f, ...g } = u, _ = g[t], v = i(_ ? d(_, f) : f);
	return n || (n = /* @__PURE__ */ new Map(), m.set(e, n)), n.set(t, v), v;
}
function _(e) {
	return e ? Object.values(t).find((t) => t === e) : void 0;
}
function v(e) {
	let t = _(e);
	if (!t) throw Error("invalid brand!");
	return t;
}
//#endregion
//#region ../../../framework/ctf-config/dist/configs/cwc.config.js
var y = {
	base: {
		_: {
			cwcUrl: "https://widget-stg.chip.de/",
			account: "chip",
			pimDownloadDetailsUrl: "https://admin.bestcheck.bf-bestcheck-production.aws.bfops.io/admin#/sw/extension/module/BcAdminIntegrationApp/downloads_product/detail/"
		},
		bunte: {
			cwcUrl: "https://widget-stg.bunte.de/",
			account: "bunte"
		},
		chip: {
			cwcUrl: "https://widget-stg.chip.de/",
			account: "chip"
		},
		focus: {
			cwcUrl: "https://widget-stg.focus.de/",
			account: "focus-online"
		},
		fitforfun: {
			cwcUrl: "https://widget-stg.fitforfun.de/",
			account: "fitforfun"
		},
		finanzen100: {
			cwcUrl: "https://widget-stg.finanzen100.de/",
			account: "finanzen100"
		}
	},
	local: {
		_: { cwcUrl: "https://widget-local.chip.de:8002/" },
		bunte: { cwcUrl: "https://widget-local.bunte.de:8002/" },
		chip: { cwcUrl: "https://widget-local.chip.de:8002/" },
		focus: { cwcUrl: "https://widget-local.focus.de:8002/" },
		fitforfun: { cwcUrl: "https://widget-local.fitforfun.de:8002/" },
		finanzen100: { cwcUrl: "https://widget-local.finanzen100.de:8002/" }
	},
	local_k8s: {
		_: { cwcUrl: "https://widget-local.chip.de:8002/" },
		bunte: { cwcUrl: "https://widget-local.bunte.de:8002/" },
		chip: { cwcUrl: "https://widget-local.chip.de:8002/" },
		focus: { cwcUrl: "https://widget-local.focus.de:8002/" },
		fitforfun: { cwcUrl: "https://widget-local.fitforfun.de:8002/" },
		finanzen100: { cwcUrl: "https://widget-local.finanzen100.de:8002/" }
	},
	sandbox: {
		_: { cwcUrl: "https://widget-sandbox.chip.de/" },
		bunte: { cwcUrl: "https://widget-sandbox.chip.de/" },
		chip: { cwcUrl: "https://widget-sandbox.chip.de/" },
		focus: { cwcUrl: "https://widget-sandbox.chip.de/" },
		fitforfun: { cwcUrl: "https://widget-sandbox.chip.de/" },
		finanzen100: { cwcUrl: "https://widget-sandbox.chip.de/" }
	},
	development: {
		_: { cwcUrl: "https://widget-dev.chip.de/" },
		bunte: { cwcUrl: "https://widget-dev.chip.de/" },
		chip: { cwcUrl: "https://widget-dev.chip.de/" },
		focus: { cwcUrl: "https://widget-dev.chip.de/" },
		fitforfun: { cwcUrl: "https://widget-dev.chip.de/" },
		finanzen100: { cwcUrl: "https://widget-dev.chip.de/" }
	},
	production: {
		_: { cwcUrl: "https://widget.chip.de/" },
		bunte: { cwcUrl: "https://widget.bunte.de/" },
		chip: { cwcUrl: "https://widget.chip.de/" },
		focus: { cwcUrl: "https://widget.focus.de/" },
		fitforfun: { cwcUrl: "https://widget.fitforfun.de/" },
		finanzen100: { cwcUrl: "https://widget.finanzen100.de/" }
	}
}, b = (e) => g(y, e), x = e("cwc-widget"), { getEntity: S, getEntityAPIClient: C } = x, w = C(), T = (e) => {
	let t = {
		_id: e._id,
		title: e.title,
		widgetType: e.widgetType,
		cwcId: e.cwcId
	};
	return e.widgetData.type === "download-page" && (t.attributes = { downloadId: e.widgetData.settings.downloadId }), t;
}, E = async (e) => T(await S(e)), D = (e, t) => `${b(e).pimDownloadDetailsUrl}${t}`, O = (e, t) => D(v(e), t), k = async (e) => (await w.get("credentials", { params: { brand: e } })).data, A = () => ({
	_id: "",
	title: "",
	cwcId: "",
	widgetType: ""
});
function j() {
	return window.GLOBAL_CONFIG;
}
var M = () => [
	"pro-con-list",
	"chapter-label",
	"download-widget",
	"download-widget-pim",
	"ir-boost-list",
	"bestcheck",
	"top-list",
	"top-list-auto-table",
	"top-list-auto-table-ecar",
	"deal-widget",
	"table",
	"bestcheck-gallery",
	"advanced-boost-widget",
	"faq-box",
	"toplist-diagram-widget",
	"car-variant",
	"car-variant-leasing",
	"factbox",
	"events",
	"download-charts",
	"download-page"
];
//#endregion
export { A as a, T as c, k as i, O as n, j as o, M as r, E as s, x as t };

//# sourceMappingURL=cwc-widget.service-CDa-9kUr.js.map